/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
 
export const KNOWLEDGE_UNIT_NAME_MAX_LEN = 100;
export const KNOWLEDGE_MAX_DOC_SIZE = 300;
export const KNOWLEDGE_MAX_SLICE_COUNT = 10000;
export const DATA_REFACTOR_CLASS_NAME = 'data-refactor';
